import { CardTitle } from '@/components/Shares/CardTitle';
import { CarouselLayout } from '@/components/Shares/CarouselLayout';
import { useLingui } from '@lingui/react';
import { Carousel } from '@mantine/carousel';
import { Box } from '@mantine/core';
import { FavoriteCard } from './FavoriteCard';
import { biggest, favorites } from './data';
export const FavoriteGames: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Box mt={20} maw={{
    md: '62em',
    lg: '75em',
    xl: '88em'
  }}>
      <CarouselLayout id="biggest-stats" items={biggest} isShadow title={<CardTitle firstText={i18n._('Favorite')} secondText={i18n._('Games')} isFirstGradient colorFrom="#FF5E9F" colorTo="#FF2E82" iconUrl="/assets/title-icons/13.png" mt={6} />} slideSize={{
      base: '40%',
      sm: '22%',
      md: '20%',
      xl: '13.33%'
    }}>
        {favorites.map(item => <Carousel.Slide key={item.id}>
            <FavoriteCard {...item} />
          </Carousel.Slide>)}
      </CarouselLayout>
    </Box>;
};